import { gql } from '@apollo/client'

export const SEND_VIDEO_CALL_REFERRAL = gql`
  mutation sendVideoCallReferral($coachAssignmentId: ID!, $email: String!) {
    sendVideoCallReferral(coachAssignmentId: $coachAssignmentId, email: $email) {
      success
    }
  }
`
